export interface CropDefault {
	name: string;
	genericName?: string | null;
	plantingSystem?: string | null; // Nursery | null (field)
	brand?: string | null;          // Albion | Proprietary#1 | null
	region?: string | null;
	season?: string | null;
	productClass?: string | null;   // baby | bunch | teen, etc.
	age?: string | null;            // caneberry stand age / planting timing
	bedWidth: number | null;
	rows: number | null;
}

export const OTHER = 'Other';
export const FIELD = 'Field';
export const NURSERY = 'Nursery';
export const BRAND_ALBION = 'Albion';

let LETTUCE: CropDefault[] = [
	{ name: 'Lettuce - Iceberg 3 row, 42-inch bed', genericName: 'Iceberg Lettuce', region: null, bedWidth: 42, rows: 3 },
	{ name: 'Lettuce-Baby (green) 80-inch bed', genericName: 'Baby green Lettuce', region: null, bedWidth: 80, rows: null },
	{ name: 'Lettuce-Baby (red) 80-inch bed', genericName: 'Baby red Lettuce', region: null, bedWidth: 80, rows: null },
	{ name: 'Lettuce-Green Leaf, 5 row, 80-inch bed', genericName: 'Green Leaf Lettuce', region: null, bedWidth: 80, rows: 5 },
	{ name: 'Lettuce-Green Leaf, 6-row, 80-inch bed', genericName: 'Green Leaf Lettuce', region: null, bedWidth: 80, rows: 6 },
	{ name: 'Lettuce-Iceberg, 2 row, 40-inch bed', genericName: 'Iceberg Lettuce', region: null, bedWidth: 40, rows: 2 },
	{ name: 'Lettuce-Iceberg, 5 row, 80-inch bed', genericName: 'Iceberg Lettuce', region: null, bedWidth: 80, rows: 5 },
	{ name: 'Lettuce-Iceberg, 6 row, 80-inch bed', genericName: 'Iceberg Lettuce', region: null, bedWidth: 80, rows: 6 },
	{ name: 'Lettuce-Red Leaf, 5 row, 80-inch bed', genericName: 'Red Leaf Lettuce', region: null, bedWidth: 80, rows: 5 },
	{ name: 'Lettuce-Red Leaf, 6 row, 80-inch bed', genericName: 'Red Leaf Lettuce', region: null, bedWidth: 80, rows: 6 },
	{ name: 'Lettuce-Romaine, 2 row, 40-inch bed', genericName: 'Romaine Lettuce', region: null, bedWidth: 40, rows: 2 },
	{ name: 'Lettuce-Romaine, 5 row, 80-inch bed', genericName: 'Romaine Lettuce', region: null, bedWidth: 80, rows: 5 },
	{ name: 'Lettuce-Romaine, 6 row, 80-inch bed', genericName: 'Romaine Lettuce', region: null, bedWidth: 80, rows: 6 },
	{ name: 'Romaine (Hawaii)', genericName: 'Romaine Lettuce', region: 'Hawaii', bedWidth: null, rows: null },
	// Demo defects for admin validation UI
	{ name: 'Lettuce - missing tags (demo)', genericName: null, region: null, bedWidth: null, rows: null },
	{ name: 'Lettuce-Iceberg duplicate (demo)', genericName: 'Iceberg Lettuce', region: null, bedWidth: 40, rows: 2 },
];

let STRAWBERRY: CropDefault[] = [
	{ name: 'Strawberry Nursery (Mother and Daughter)', genericName: 'Strawberry', plantingSystem: NURSERY, brand: null, region: null, season: null, bedWidth: null, rows: null },
	{ name: 'Strawberry, 4 row, 68-inch bed, fall Oxnard', genericName: 'Strawberry', plantingSystem: null, brand: null, region: 'Oxnard', season: 'fall', bedWidth: 68, rows: 4 },
	{ name: 'Strawberry-Albion, 2 row, 52-inch bed', genericName: 'Strawberry', plantingSystem: null, brand: BRAND_ALBION, region: null, season: null, bedWidth: 52, rows: 2 },
	{ name: 'Strawberry-Albion, 4 row, 64-inch bed', genericName: 'Strawberry', plantingSystem: null, brand: BRAND_ALBION, region: null, season: null, bedWidth: 64, rows: 4 },
	{ name: 'Strawberry-Proprietary#1, 2 row, 48-inch bed', genericName: 'Strawberry', plantingSystem: null, brand: 'Proprietary#1', region: null, season: null, bedWidth: 48, rows: 2 },
	{ name: 'Strawberry-Proprietary#1, 2 row, 52-inch bed', genericName: 'Strawberry', plantingSystem: null, brand: 'Proprietary#1', region: null, season: null, bedWidth: 52, rows: 2 },
];

let BRUSSELS_SPROUTS: CropDefault[] = [
	{ name: 'Brussels sprouts 1 row, 40 inch bed (summer/fall harvest)', genericName: 'Brussels sprouts', season: 'summer/fall harvest', bedWidth: 40, rows: 1 },
	{ name: 'Brussels sprouts 1 row, 40 inch bed (winter harvest)', genericName: 'Brussels sprouts', season: 'winter harvest', bedWidth: 40, rows: 1 },
];

let SPINACH: CropDefault[] = [
	{ name: 'Spinach (baby) 80-inch bed', genericName: 'Spinach', productClass: 'baby', bedWidth: 80, rows: null },
	{ name: 'Spinach (bunch) 80-inch bed', genericName: 'Spinach', productClass: 'bunch', bedWidth: 80, rows: null },
	{ name: 'Spinach (teen) 80-inch bed', genericName: 'Spinach', productClass: 'teen', bedWidth: 80, rows: null },
];

let WALNUT: CropDefault[] = [
	{ name: 'Walnut Sacramento Valley', genericName: 'Walnut', region: 'Sacramento Valley', bedWidth: null, rows: null },
	{ name: 'Walnut Southern San Joaquin Valley', genericName: 'Walnut', region: 'Southern San Joaquin Valley', bedWidth: null, rows: null },
];

let WATERMELON: CropDefault[] = [
	{ name: 'Watermelon (Guam)', genericName: 'Watermelon', region: 'Guam', bedWidth: null, rows: null },
];

let SQUASH: CropDefault[] = [
	{ name: 'Zucchini (Hawaii)', genericName: 'Zucchini', region: 'Hawaii', bedWidth: null, rows: null },
];

let TOMATO: CropDefault[] = [
	{ name: 'Cherry Tomato (Guam)', genericName: 'Cherry Tomato', region: 'Guam', bedWidth: null, rows: null },
	{ name: 'Processing tomato transplanted 60-inch bed', genericName: 'Processing tomato', region: null, bedWidth: 60, rows: null },
];

let EGGPLANT: CropDefault[] = [
	{ name: 'Eggplant (Guam and Hawaii)', genericName: 'Eggplant', region: 'Guam and Hawaii', bedWidth: null, rows: null },
];

let CANEBERRY: CropDefault[] = [
	{ name: 'Raspberry proprietary variety #1, 2nd year, 88-inch row spacing', genericName: 'Raspberry', age: '2nd year', bedWidth: null, rows: null },
	{ name: 'Raspberry proprietary variety#1, 1st year early planting, 88-inch row spacing', genericName: 'Raspberry', age: '1st year early planting', bedWidth: null, rows: null },
	{ name: 'Raspberry proprietary variety#1, 1st year late planting, 88-inch row spacing', genericName: 'Raspberry', age: '1st year late planting', bedWidth: null, rows: null },
];

let ALFALFA: CropDefault[] = [
	{ name: 'Alfalfa', genericName: 'Alfalfa', bedWidth: null, rows: null },
];

let ALMOND: CropDefault[] = [
	{ name: 'Almond Sacramento Valley', genericName: 'Almond', region: 'Sacramento Valley', bedWidth: null, rows: null },
	{ name: 'Almond Southern San Joaquin Valley', genericName: 'Almond', region: 'Southern San Joaquin Valley', bedWidth: null, rows: null },
];

let ARTICHOKE: CropDefault[] = [
	{ name: 'Annual Artichoke 40-inch beds summer', genericName: 'Artichoke', bedWidth: 40, rows: null },
	{ name: 'Annual Artichoke 80-inch beds summer', genericName: 'Artichoke', bedWidth: 80, rows: null },
];

let ASIAN_GREENS: CropDefault[] = [
	{ name: 'Choy Sum', genericName: 'Choy Sum', bedWidth: null, rows: null },
	{ name: 'Mizuna 80-inch bed', genericName: 'Mizuna', bedWidth: 80, rows: null },
];

let BABY_SALAD_GREENS: CropDefault[] = [
	{ name: 'Arugula baby green (Hawaii)', genericName: 'Arugula', region: 'Hawaii', bedWidth: null, rows: null },
	{ name: 'Red Russian Kale baby green (Hawaii)', genericName: 'Red Russian Kale', region: 'Hawaii', bedWidth: null, rows: null },
];

let BROCCOLI: CropDefault[] = [
	{ name: 'Broccoli (Hawaii)', genericName: 'Broccoli', region: 'Hawaii', season: null, bedWidth: null, rows: null },
	{ name: 'Broccoli 2 row, 40-inch bed, summer', genericName: 'Broccoli', region: null, season: 'summer', bedWidth: 40, rows: 2 },
	{ name: 'Broccoli 2 row, 40-inch bed, winter', genericName: 'Broccoli', region: null, season: 'winter', bedWidth: 40, rows: 2 },
];

let CABBAGE: CropDefault[] = [
	{ name: 'Cabbage-green, transplanted, 2 row, 40-inch bed', genericName: 'Green cabbage', bedWidth: 40, rows: 2 },
	{ name: 'Cabbage-red, transplanted, 2 row, 40-inch bed', genericName: 'Red cabbage', bedWidth: 40, rows: 2 },
	{ name: 'Head cabbage (Hawaii)', genericName: 'Head cabbage', region: 'Hawaii', bedWidth: null, rows: null },
];

let CARROT: CropDefault[] = [
	{ name: 'Carrot Freshmarket Desert winter 40-inch bed 10 rows', genericName: 'Carrot', region: 'Desert', season: 'winter', bedWidth: 40, rows: 10 },
];

let CAULIFLOWER: CropDefault[] = [
	{ name: 'Cauliflower-transplanted, 1 row, 40-inch bed, summer', genericName: 'Cauliflower', season: 'summer', bedWidth: 40, rows: 1 },
	{ name: 'Cauliflower-transplanted, 1 row, 40-inch bed, winter', genericName: 'Cauliflower', season: 'winter', bedWidth: 40, rows: 1 },
];

let CELERY: CropDefault[] = [
	{ name: 'Celery transplant, 40-inch bed, 2 rows', genericName: 'Celery', bedWidth: 40, rows: 2 },
];

let CHICORY: CropDefault[] = [
	{ name: 'Endive, 5 row, 80-inch bed', genericName: 'Endive', bedWidth: 80, rows: 5 },
	{ name: 'Escarole, 5 row, 80-inch bed', genericName: 'Escarole', bedWidth: 80, rows: 5 },
];

let CHINESE_CABBAGE: CropDefault[] = [
	{ name: 'Bok choy 2 rows, 40-inch beds, summer', genericName: 'Bok choy', region: null, season: 'summer', productClass: null, bedWidth: 40, rows: 2 },
	{ name: 'Chinese Cabbage/Wong Bok (American Samoa)', genericName: 'Wong Bok', region: 'American Samoa', bedWidth: null, rows: null },
	{ name: 'Chinese cabbage/Wong Bok (Hawaii)', genericName: 'Wong Bok', region: 'Hawaii', bedWidth: null, rows: null },
	{ name: 'Napa Cabbage 2 rows, 40-inch beds summer', genericName: 'Napa Cabbage', region: null, season: 'summer', bedWidth: 40, rows: 2 },
	{ name: 'Pak Choi (American Samoa)', genericName: 'Pak Choi', region: 'American Samoa', productClass: null, bedWidth: null, rows: null },
	{ name: 'Pak choy baby (Hawaii)', genericName: 'Pak Choi', region: 'Hawaii', productClass: 'baby', bedWidth: null, rows: null },
];

let CILANTRO: CropDefault[] = [
	{ name: 'Cilantro (Hawaii)', genericName: 'Cilantro', region: 'Hawaii', bedWidth: null, rows: null },
	{ name: 'Cilantro 80-inch bed', genericName: 'Cilantro', region: null, bedWidth: 80, rows: null },
];

let CITRUS: CropDefault[] = [
	{ name: 'Lemon', genericName: 'Lemon', bedWidth: null, rows: null },
	{ name: 'Mandarin', genericName: 'Mandarin', bedWidth: null, rows: null },
	{ name: 'Orange', genericName: 'Orange', bedWidth: null, rows: null },
];

let CUCUMBER: CropDefault[] = [
	{ name: 'Cucumber (American Samoa)', genericName: 'Cucumber', region: 'American Samoa', bedWidth: null, rows: null },
];

let EDIBLE_HIBISCUS: CropDefault[] = [
	{ name: 'Edible Hibiscus (American Samoa)', genericName: 'Edible Hibiscus', region: 'American Samoa', bedWidth: null, rows: null },
];

let FENNEL: CropDefault[] = [
	{ name: 'Fennel transplant 40-inch beds', genericName: 'Fennel', bedWidth: 40, rows: null },
];

let GRAPE: CropDefault[] = [
	{ name: 'Table Grape', genericName: 'Table grape', region: null, bedWidth: null, rows: null },
	{ name: 'Wine Grape Central Coast', genericName: 'Wine grape', region: 'Central Coast', bedWidth: null, rows: null },
	{ name: 'Wine Grape San Joaquin Valley', genericName: 'Wine grape', region: 'San Joaquin Valley', bedWidth: null, rows: null },
];

let MAIZE: CropDefault[] = [
	{ name: 'Seed corn (Hawaii)', genericName: 'Seed corn', region: 'Hawaii', bedWidth: null, rows: null },
];

let ONION: CropDefault[] = [
	{ name: 'Onion (Hawaii)', genericName: 'Onion', region: 'Hawaii', bedWidth: null, rows: null },
];

let PEAR: CropDefault[] = [
	{ name: 'Pear Sacramento Valley', genericName: 'Pear', region: 'Sacramento Valley', bedWidth: null, rows: null },
];

let PEAS: CropDefault[] = [
	{ name: 'Pea', genericName: 'Pea', bedWidth: null, rows: null },
];

let PEPPERS: CropDefault[] = [
	{ name: 'Chili pepper (Guam)', genericName: 'Chili', region: 'Guam', bedWidth: null, rows: null },
	{ name: 'Red Bell pepper transplanted 1-row, 40-inch bed', genericName: 'Red Bell', bedWidth: 40, rows: 1 },
];

let PISTACHIO: CropDefault[] = [
	{ name: 'Pistachio Sacramento Valley', genericName: 'Pistachio', region: 'Sacramento Valley', bedWidth: null, rows: null },
	{ name: 'Pistachio San Joaquin Valley', genericName: 'Pistachio', region: 'San Joaquin Valley', bedWidth: null, rows: null },
];

let PRUNE: CropDefault[] = [
	{ name: 'Prune Sacramento Valley', genericName: 'Prune', region: 'Sacramento Valley', bedWidth: null, rows: null },
];

export let BY_COMMODITY: { [k: string]: CropDefault[] } = {
	Alfalfa: ALFALFA,
	Almond: ALMOND,
	Artichoke: ARTICHOKE,
	'Asian Greens': ASIAN_GREENS,
	'Baby Salad Greens': BABY_SALAD_GREENS,
	Broccoli: BROCCOLI,
	'Brussels Sprouts': BRUSSELS_SPROUTS,
	Cabbage: CABBAGE,
	Caneberry: CANEBERRY,
	Carrot: CARROT,
	Cauliflower: CAULIFLOWER,
	Celery: CELERY,
	Chicory: CHICORY,
	'Chinese Cabbage': CHINESE_CABBAGE,
	Cilantro: CILANTRO,
	Citrus: CITRUS,
	Cucumber: CUCUMBER,
	'Edible Hibiscus': EDIBLE_HIBISCUS,
	Eggplant: EGGPLANT,
	Fennel: FENNEL,
	Grape: GRAPE,
	Lettuce: LETTUCE,
	Maize: MAIZE,
	Onion: ONION,
	Pear: PEAR,
	Peas: PEAS,
	Peppers: PEPPERS,
	Pistachio: PISTACHIO,
	Prune: PRUNE,
	Spinach: SPINACH,
	Squash: SQUASH,
	Strawberry: STRAWBERRY,
	Tomato: TOMATO,
	Walnut: WALNUT,
	Watermelon: WATERMELON,
};